import { useQuery } from 'react-query';
import { getAPI } from '../../services/api';
import {
  QUERY,
  ENTITY,
  PROJECT_KEY,
  CHANNEL_CONFIG_MAP,
} from '../../constants/content';
import { useCommonQueryParams } from './useCommonQueryParams';
import { sdkErrorHandler } from '../../utils';

export const QUERY_KEY_RULES = 'rules';

export const useQueryRules = (queryOptions = {}) => {
  const { language, brand, channel, contentAPIPrefix } = useCommonQueryParams();

  const query = {
    [QUERY.IS_ACTIVE]: 'true',
    [QUERY.PROJECT]: PROJECT_KEY,
    [QUERY.LANGUAGE_ID]: language,
    [QUERY.CHANNELS]: CHANNEL_CONFIG_MAP[channel.toUpperCase()],
    [QUERY.BRANDS]: brand.toUpperCase(),
  };

  const searchParams = new URLSearchParams(query);

  const url = `/${ENTITY.RULES}?${searchParams}`;
  const fetch = ({ signal }) =>
    getAPI()
      .fetch(url, { signal, baseUrl: contentAPIPrefix })
      .catch(
        sdkErrorHandler({
          queryOptions,
          source: `fetch to ${url}`,
          baseUrl: contentAPIPrefix,
        })
      );

  return useQuery([QUERY_KEY_RULES, language], fetch, {
    ...queryOptions,
  });
};

export const useQueryRulesDetails = (id, queryOptions = {}) => {
  const { language, brand, channel, contentAPIPrefix } = useCommonQueryParams();

  const query = {
    [QUERY.IS_ACTIVE]: 'true',
    [QUERY.PROJECT]: PROJECT_KEY,
    [QUERY.LANGUAGE_ID]: language,
    [QUERY.CHANNELS]: CHANNEL_CONFIG_MAP[channel.toUpperCase()],
    [QUERY.BRANDS]: brand.toUpperCase(),
    id,
  };

  const searchParams = new URLSearchParams(query);

  const url = `/${ENTITY.RULES}?${searchParams}`;
  const fetch = ({ signal }) =>
    getAPI()
      .fetch(url, { signal, baseUrl: contentAPIPrefix })
      .catch(
        sdkErrorHandler({
          queryOptions,
          source: `fetch to ${url}`,
          baseUrl: contentAPIPrefix,
        })
      );

  return useQuery([QUERY_KEY_RULES, language, id], fetch, {
    ...queryOptions,
    select: (data) => data?.[0],
  });
};
